



















































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { addRound, editRound, deleteRound, queryCompanyStageDate } from '@/api/project';
import roundSelect from '@/components/base/roundSelect.vue';
import roundLine from '@/components/project/roundList.vue';

import moment from 'moment';

import { getDetail, historyStage } from '@/api/project';

const columns = [
  {
    title: '轮次',
    dataIndex: 'roundName',
    width: '100px',
    key: 'roundName',
    align: 'center',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '阶段',
    dataIndex: 'roundPhase',
    width: '100px',
    key: 'roundPhase',
    align: 'center',
    scopedSlots: { customRender: 'phase' }
  },
  {
    title: '操作',
    key: 'action',
    width: '100px',
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
];

const data = [];

@Component({
  components: { roundLine, roundSelect }
})
class round extends Vue {
  roundList: any[] = [];
  roundListChanged: any[] = [];
  dateSet: any[] = [];
  dateSetNow: any = ''; // 选了第一个日期后,设定dateSetNow为选中日期所在的dateSet对象
  dateSetNow2: any = ''; // 基于dateSetNow,用于设置datePicker2的disable-date
  dateSetNow3: any = ''; // 基于dateSetNow,用于通过datePicker2反向设置datePicker1的disable-date
  // historyStageMap: any = {};
  data: any[] = data;
  columns: any[] = columns;
  projectId: any = this.$route.query.projectId;
  projectName: string = '';
  selectRoundNow: number = -1;
  form: any = {
    startDate: undefined,
    endDate: undefined,
    round: undefined
  };

  roundNow: any = {
    round: 0,
    roundName: '',
    roundDate: []
  };

  rules: any = {
    round: [],
    startDate: [],
    endDate: []
  };

  itemInfo: any = {
    round: 'roundName',
    startDate: 'startDate',
    endDate: 'endDate',
    warning: 'test'
  };

  labelCol: any = { span: 3 };
  wrapperCol: any = { span: 8 };
  editType: number = 0; // 0:没在编辑,1:新建,2:修改,3:删除

  visible: boolean = false;

  modalTitle: string = '新建轮次';

  editTypeMap: any = {
    0: '默认',
    1: '新建',
    2: '修改',
    3: '删除'
  };

  itemInfoSet: any = {
    1: {
      round: '',
      startDate: '默认取百川中决策/启动时间，如果没有则需手动填写，且需晚于前一轮交割时间，早于后一轮上会时间',
      endDate: '默认取百川中交割时间，如果没有则需手动填写，且需晚于前一轮交割时间，早于后一轮上会时间'
    },
    2: {
      round: '仅支持修改为当前项目中没有的轮次',
      startDate: '默认取百川中决策/启动时间，如果没有默认取原来轮次的时间，支持手动修改',
      endDate: '默认取百川中交割时间，如果没有默认取原来轮次的时间，支持手动修改'
    },
    3: {
      round: '附件包括：文件/notes/会议/vote，仅支持转移为当前项目中已有轮次',
      startDate: '',
      endDate: ''
    }
  };

  get showWarning() {
    return ['round', 'startDate', 'endDate'].find(_ => {
      return this.rules[_].length > 0 && !this.form[_];
    })
      ? false
      : true;
  }

  // 当前轮次是否保密(为最新轮融资期)
  get roundNowIsSecret() {
    // return this.roundList.find(_ => _.round === this.roundNow['round'] && _.phase === 0) ? false : true;
    let latestRound = this.roundList[this.roundList.length - 1];
    return latestRound && latestRound['round'] === this.roundNow['round'] && latestRound['phase'] === 1 ? true : false;
  }

  // 修改后轮次是否保密(为最新轮融资期)
  get roundChangedIsSecret() {
    // return this.roundList.find(_ => _.round === this.form.round && _.phase === 0) ? false : true;
    let latestRound = this.roundListChanged[this.roundListChanged.length - 1];
    return latestRound && latestRound['round'] === this.form.round && latestRound['phase'] === 1 ? true : false;
  }

  // 新插入轮次为保密
  get roundNewIsSecret() {
    return this.form.startDate && !this.form.endDate && this.rules['endDate'].length === 0 ? true : false;
  }

  // 生成必填校验规则
  ruleTmp(str) {
    return { required: true, message: '请选择' + str, trigger: 'change' };
  }

  mounted() {
    this.getDetail();
    this.getHistoryStage();
  }

  async roundChange(round) {
    // 轮次新建或修改(editType=1||2)时触发roundListChanged重新渲染
    this.form.roundName = round.roundName;

    if (this.editType === 1 || this.editType === 2) {
      try {
        let res = await queryCompanyStageDate({
          companyId: this.projectId,
          roundId: round['round']
        });
        if (res.code === 200) {
          let { startDate, endDate } = res.data;

          if (startDate && this.isOptionalDate(moment(startDate), 1)) {
            this.form.startDate = moment(startDate);
            // 设定dateSetNow & dateSetNow2
            // this.initDateDisable(0);
            this.initDateDisable(1);
            if (endDate) {
              this.form.endDate = moment(endDate);
              this.initDateDisable(2);
            }
          } else if (this.roundNow['roundDate'].length > 0) {
            // 选的轮次没有百川对应,时间重置为所选时间
            this.form.startDate = moment(this.roundNow['roundDate'][0]);
            // this.initDateDisable(0);
            this.initDateDisable(1);
            this.form.endDate = this.roundNow['roundDate'].length === 2 ? moment(this.roundNow['roundDate'][1]) : null;
            if (this.form.endDate) {
              this.initDateDisable(2);
            }
          } else {
            this.form.startDate = undefined;
            this.form.endDate = undefined;
          }
        }
        this.createNewRoundList();
      } catch (err) {
        console.log(err);
      }
    }
  }

  showModal(type, row) {
    this.editType = type;
    this.visible = true;
    this.rules = {
      round: [],
      startDate: [],
      endDate: []
    };
    this.itemInfo = this.itemInfoSet[type];

    // 1 必填round startDate
    // 2 必填round startDate
    // 2 必填round
    if (type === 1) {
      this.rules['round'].push(this.ruleTmp('轮次'));
      this.rules['startDate'].push(this.ruleTmp('融资期开始时间'));

      this.roundNow['round'] = 0;
      this.roundNow['roundName'] = '';
      this.roundNow['roundDate'] = [];

      this.initDateSet(this.roundList.filter(_ => _.round !== 1));
    }

    if (type === 2) {
      this.rules['round'].push(this.ruleTmp('轮次'));
      this.rules['startDate'].push(this.ruleTmp('融资期开始时间'));

      this.roundNow['round'] = row.round;
      this.roundNow['roundName'] = row.roundName;
      this.roundNow['roundDate'] = row.roundDate;

      // 先删除第一轮&当前轮次
      let roundListTmp = this.roundList.filter(_ => _.round !== this.roundNow.round && _.round !== 1);
      // init dateSet
      this.initDateSet(roundListTmp);

      // 初始化时间
      let tmp = this.roundList.find(_ => _.round === row.round && _.phase === 1);
      let tmp2 = this.roundList.find(_ => _.round === row.round && _.phase === 0);
      // 如果startDate为空.则设定starDate等于endDate
      this.form.startDate = tmp ? moment(tmp['date']) : moment(tmp2['date']);
      // 设定dateSetNow & dateSetNow2
      // this.initDateDisable(0);
      this.initDateDisable(1);

      this.form.endDate = tmp2 ? moment(tmp2['date']) : null;
      // 如果有endDate initDateSetNow2
      if (this.form.endDate) {
        this.initDateDisable(2);
      }

      // console.log('date', this.form.startDate, this.form.endDate);
      // 初始化修改后预览
      this.roundListChanged = [];
    }

    if (type === 3) {
      this.roundNow['round'] = row.round;
      this.roundNow['roundName'] = row.roundName;
      this.createNewRoundList();
      this.$nextTick(() => {
        this.rules['round'].push(this.ruleTmp('轮次'));
      });
    }
  }

  async handleOk(e) {
    console.log(e);
    //@ts-ignore
    this.$refs.ruleForm.validate(valid => {
      if (valid) {
        this.roundEdit();
      } else {
        return false;
      }
    });
  }

  handleCancel(e) {
    console.log(e);
    //@ts-ignore
    this.$refs.ruleForm.resetFields();
    this.form = {
      startDate: undefined,
      endDate: undefined,
      round: undefined
    };
  }

  async roundEdit() {
    try {
      let res;
      // console.log(this.form.startDate.toDate());

      switch (this.editType) {
      case 1: {
        res = await addRound({
          projectId: this.projectId,
          roundId: this.form.round,
          startDate: this.form.startDate.valueOf(),
          endDate: this.form.endDate ? this.form.endDate.valueOf() : ''
        });
        break;
      }
      case 2: {
        res = await editRound({
          projectId: this.projectId,
          oldRoundId: this.roundNow['round'],
          newRoundId: this.form.round,
          startDate: this.form.startDate.valueOf(),
          endDate: this.form.endDate ? this.form.endDate.valueOf() : ''
        });
        break;
      }
      case 3: {
        res = await deleteRound({
          projectId: this.projectId,
          oldRoundId: this.roundNow['round'],
          newRoundId: this.form.round
        });
        break;
      }
      default:
        break;
      }
      if (res.code === 200) {
        // 重新请求roundList
        this.$message.success('提交成功');
        this.visible = false;
        this.form = {
          startDate: undefined,
          endDate: undefined,
          round: undefined
        };
        this.getHistoryStage();
        this.roundListChanged = [];
        // this.initDateDisable(1);
        return '';
      }
      return '';
    } catch (err) {
      console.log(err);
    }
  }
  dateChange(val, type) {
    // 选了开始时间
    if (type === 1) {
      // this.initDateDisable(0);
      this.initDateDisable(1);
      this.createNewRoundList();
    }
    // 选了结束时间
    else if (type === 2) {
      if (val) {
        // 重新设定datePicker1的disable
        this.initDateDisable(2);
      }
      this.createNewRoundList();
    }
  }

  // 传入roundList,无第一轮
  initDateSet(roundListTmp) {
    let dateTmp;
    this.dateSet = [];
    // 构建dateSet
    // 是一个对象数组,每个对象包含startDate/endDate/round/roundName/phase/roundAfter
    // 构建一个合法的时间区间
    // 第一个对象只有endDate,最后一个只有startDate
    // 每轮发展期(如果没有的话就是融资期)的date为starDate,下一轮融资期的开始是endDate
    if (roundListTmp.length > 0) {
      roundListTmp.forEach((_, index) => {
        // 创建第一条只有endDate的
        if (index === 0) {
          let hasDevelopment = this.roundList.find(_ => _.round === 1 && _.phase === 0);
          // phase 如果存在第一轮发展期,则dateSet的phase置0
          this.dateSet.push({ startDate: '', endDate: _.dateMoment, round: 1, roundName: '第一', roundAfter: _.round, phase: hasDevelopment ? 0 : 1 }); // -1
        }
        // 是融资期
        if (_.phase === 1) {
          if (index !== 0) {
            dateTmp['endDate'] = _.dateMoment; // -1
            dateTmp['roundAfter'] = _.round; // -1
            this.dateSet.push(dateTmp);
          }
          dateTmp = { startDate: _.dateMoment, endDate: '', round: _.round, roundName: _.roundName, phase: _.phase }; // +1
        }
        // 是发展期
        else if (_.phase === 0) {
          // 如果和当前最新dateSet的round一样,就改startDate和phase
          if (dateTmp['round'] === _.round) {
            dateTmp['startDate'] = _.dateMoment; // +1
            dateTmp['phase'] = _.phase; // +1
          }
          // 如果不是(该轮次只存在发展期),就push一个新的
          else {
            this.dateSet.push({ startDate: _.dateMoment, endDate: '', round: _.round, roundName: _.roundName, phase: _.phase }); // -1
          }
        }
      });
      // 把最后一个只有startDate的对象push了
      this.dateSet.push(dateTmp);
    } else {
      let hasDevelopment = this.roundList.find(_ => _.round === 1 && _.phase === 0);
      this.dateSet.push({ round: 1, roundName: '第一', phase: hasDevelopment ? 0 : 1 });
    }
  }

  // type: 1 datePicker1选中,需要遍历dateSet,设定this.dateSetNow
  // type: 1 且在dateSetNow基础上构建第二个datePicker的disabled时间dateSetNow2
  // type: 2 在选了datePicker2的情况下反向限制datePicker1的disabled时间dateSetNow3
  initDateDisable(type) {
    if (type === 1) {
      this.dateSet.forEach(_ => {
        if (!_.startDate && !_.endDate) {
          this.dateSetNow = _;
          this.rules['endDate'] = [];
        } else if (!_.startDate) {
          if (moment(this.form.startDate).isBefore(_.endDate, 'day')) {
            this.dateSetNow = _;
            this.rules['endDate'].push(this.ruleTmp('融资期结束时间'));
          }
        } else if (!_.endDate) {
          if (moment(this.form.startDate).isAfter(_.startDate, 'day')) {
            this.dateSetNow = _;
            this.rules['endDate'] = [];
          }
        } else {
          if (moment(this.form.startDate).isBetween(_.startDate, _.endDate, 'day')) {
            this.dateSetNow = _;
            this.rules['endDate'].push(this.ruleTmp('融资期结束时间'));
          }
        }
      });
      this.dateSetNow2 = { ...this.dateSetNow };
      this.dateSetNow2['startDate'] = this.form.startDate;
    } else if (type === 2) {
      this.dateSetNow3 = { ...this.dateSetNow };
      this.dateSetNow3['endDate'] = this.form.endDate;
    }
  }

  // 返回新增的轮次对象数组
  createNewRound() {
    let res = [];
    let tmp: any = {};
    if (this.form.startDate) {
      // 前一个轮次自动生成发展期
      if (this.dateSetNow.phase === 1) {
        tmp = {
          round: this.dateSetNow.round,
          roundName: this.dateSetNow.roundName,
          phase: 0,
          date: this.form.startDate
            .clone()
            .subtract(1, 'd')
            .valueOf(),
          dateMoment: this.form.startDate.clone().subtract(1, 'd')
        };
        //@ts-ignore
        res.push(tmp);
      }
      // 新增轮次的融资期
      tmp = {
        round: this.form.round,
        roundName: this.form.roundName,
        phase: 1,
        date: this.form.startDate.valueOf(),
        dateMoment: this.form.startDate.clone(),
        isChange: true
      };
      //@ts-ignore
      res.push(tmp);
    }
    // 有发展期的话
    if (this.form.endDate) {
      tmp = {
        round: this.form.round,
        roundName: this.form.roundName,
        phase: 0,
        date: this.form.endDate.valueOf(),
        dateMoment: this.form.endDate.clone(),
        isChange: true
      };
      //@ts-ignore
      res.push(tmp);
    }
    return res;
  }

  // 遍历roundList,调用createNewRound得到新增的轮次,插入到roundList对应位置,组合得到roundListChanged
  createNewRoundList() {
    this.roundListChanged = [];
    if (this.editType === 1 || this.editType === 2) {
      // 判断是第一轮,且dateSetNow插入在最开始,且时间早于第一轮时间
      // 计算第一轮最晚时间和datePicker1的时间差delay,用于修改第一轮时间
      let flag = false;
      let delay = 0;
      let roundOne = this.data.find(_ => _.round === 1);
      if (!this.dateSetNow['startDate']) {
        let roundDate = roundOne['roundDate'][roundOne['roundDate'].length - 1];
        if (moment(roundDate).isAfter(this.form.startDate)) {
          delay = moment(roundDate).diff(this.form.startDate);
          flag = true;
        }
      }
      this.roundList.forEach(_ => {
        // 新轮次插入到轮次中间
        if (_.round === this.dateSetNow.roundAfter && _.phase === 1) {
          let tmp = this.createNewRound();
          this.roundListChanged.push(...tmp);
        }
        // 如果早于第一轮,则需修改第一轮时间
        if (flag && _.round === 1) {
          this.roundListChanged.push({
            ..._,
            dateMoment: _.dateMoment
              .clone()
              .subtract(delay)
              .subtract(1, 'd'),
            date: _.dateMoment
              .clone()
              .subtract(delay)
              .subtract(1, 'd')
              .valueOf()
          });
        } else {
          if (this.editType === 2 && _.round === this.roundNow.round) {
          } else {
            this.roundListChanged.push(_);
          }
        }
      });
      // 新轮次插入到最后
      if (!this.dateSetNow.roundAfter) {
        let tmp = this.createNewRound();
        this.roundListChanged.push(...tmp);
      }
    } else if (this.editType === 3) {
      this.roundListChanged = this.roundList.filter(_ => _.round !== this.roundNow.round);
    }
  }

  // type:1 是初始化datePicker1,需要遍历dateSet,返回flag
  // type:2 是是初始化datePicker2,需要通过this.dateSetNow2,返回flag
  // type:3 是datePicker2选中后,反向设定datePicker1的disabled,返回flag
  isOptionalDate(current, type) {
    let flag = false;
    if (type === 2) {
      if (!this.dateSetNow2.endDate) {
        if (moment(current).isAfter(this.dateSetNow2.startDate, 'day')) {
          flag = true;
        }
      } else {
        if (moment(current).isBetween(this.dateSetNow2.startDate, this.dateSetNow2.endDate, 'day')) {
          flag = true;
        }
      }
    } else if (type === 3) {
      if (!this.dateSetNow3.startDate) {
        if (moment(current).isBefore(this.dateSetNow3.endDate, 'day')) {
          flag = true;
        }
      } else {
        if (moment(current).isBetween(this.dateSetNow3.startDate, this.dateSetNow3.endDate, 'day')) {
          flag = true;
        }
      }
    } else {
      if (this.dateSet.length === 0) {
        flag = true;
      } else {
        this.dateSet.forEach(_ => {
          if (!_.startDate && !_.endDate) {
            flag = true;
          } else if (!_.startDate) {
            if (moment(current).isBefore(_.endDate, 'day')) {
              flag = true;
            }
          } else if (!_.endDate) {
            if (moment(current).isAfter(_.startDate, 'day')) {
              flag = true;
            }
          } else {
            if (moment(current).isBetween(_.startDate, _.endDate, 'day')) {
              flag = true;
            }
          }
        });
      }
    }
    return flag;
  }

  disabledDate(current, type) {
    // true的话disable
    return !this.isOptionalDate(current, type);
  }

  async getHistoryStage() {
    try {
      let res = await historyStage({ id: this.$route.query.projectId, type: 1 });
      if (res.code === 200) {
        this.roundList = res.data;
        this.data = [];
        // 创建表格数据
        this.roundList.forEach(e => {
          // 判断data里有没有round
          let tmp = this.data.find(e2 => e2.round === e.round);
          if (tmp) {
            tmp.roundPhase.push(e.phase);
            tmp.roundDate.push(e.date);
          } else {
            this.data.push({
              round: e.round,
              roundName: e.roundName,
              roundPhase: [e.phase],
              roundDate: [e.date]
            });
          }
        });

        this.formatHistoryStage();
        // 删除第一轮
        this.initDateSet(this.roundList.filter(_ => _.round !== 1));
      }
    } catch (err) {
      console.log(err);
    }
  }

  formatHistoryStage() {
    // 时间从时间戳转moment
    this.roundList.forEach(_ => {
      _.dateMoment = moment(_.date);
    });
  }

  async getDetail() {
    const { data } = await getDetail(this.$route.query.projectId);
    this.projectName = data.base.name;
  }
}
export default round;
